import { createUserWithEmailAndPassword } from "firebase/auth";
import React, { useState } from "react";
import { auth, db, storage } from "../utils/firebase"; // Add storage import
import { setDoc, doc } from "firebase/firestore";
import { toast } from "react-toastify";
import Modals from "./regmodals/ModalsReg";
import { useNavigate } from "react-router-dom";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; // Import functions for Firebase Storage
import "../styles/Login.css";

function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [gender, setGender] = useState("");
  const [birthday, setBirthday] = useState({ month: "", day: "", year: "" });
  const currentYear = new Date().getFullYear();
  const [errorMessage, setErrorMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    if (password.length < 6) {
      setErrorMessage("Password must be at least 6 characters long.");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (user) {
     
        const defaultProfileImageRef = ref(storage, "profile_images/user-profile.jpg");


        const defaultProfileImageUrl = await getDownloadURL(defaultProfileImageRef);

     
        await setDoc(doc(db, "Users", user.uid), {
          email: user.email,
          firstName: fname,
          lastName: lname,
          gender: gender,
          birthday: `${birthday.month} ${birthday.day}, ${birthday.year}`,
          photo: defaultProfileImageUrl, 
          profile_image: defaultProfileImageUrl,
          role: "user",
          password: password,
        });
      }

      setModalMessage("You have been successfully registered!");
      setIsModalOpen(true);
      console.log("User Registered Successfully!!");
      toast.success("User Registered Successfully!!", {
        position: "top-center",
      });
    } catch (error) {
      console.log(error.message);
      toast.error(error.message, {
        position: "bottom-center",
      });
    }
  };

  const closeModal = () => {
    setEmail("");
    setPassword("");
    setFname("");
    setLname("");
    setGender("");
    setBirthday({ month: "", day: "", year: "" });
    setIsModalOpen(false);
    navigate("/login");
  };

  return (
    <div>
      <form onSubmit={handleRegister}>
        <h3>Sign Up</h3>
        <div className="mb-3">
          <label>First name</label>
          <input
            type="text"
            className="form-control"
            placeholder="First name"
            onChange={(e) => setFname(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label>Last name</label>
          <input
            type="text"
            className="form-control"
            placeholder="Last name"
            onChange={(e) => setLname(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label>Gender</label>
          <select
            className="form-control"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            required
          >
            <option value="" disabled selected hidden>
              Select Gender
            </option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Prefer not to say">Prefer not to say</option>
          </select>
        </div>
        <div className="mb-3">
          <label>Birthday</label>
          <div className="birthday-fields">
            <select
              className="form-control"
              value={birthday.month}
              onChange={(e) => setBirthday({ ...birthday, month: e.target.value })}
              required
            >
              <option value="">Month</option>
              {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month, index) => (
                <option key={index} value={month}>{month}</option>
              ))}
            </select>
            <select
              className="form-control"
              value={birthday.day}
              onChange={(e) => setBirthday({ ...birthday, day: e.target.value })}
              required
            >
              <option value="">Day</option>
              {[...Array(31).keys()].map((day) => (
                <option key={day + 1} value={day + 1}>{day + 1}</option>
              ))}
            </select>
            <select
              className="form-control"
              value={birthday.year}
              onChange={(e) => setBirthday({ ...birthday, year: e.target.value })}
              required
            >
              <option value="">Year</option>
              {[...Array(120).keys()].map((_, i) => (
                <option key={currentYear - i} value={currentYear - i}>
                  {currentYear - i}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="mb-3">
          <label>Email address</label>
          <input
            type="email"
            className="form-control"
            placeholder="Enter email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label>Password</label>
          <input
            type="password"
            className="form-control"
            placeholder="Enter password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {errorMessage && <small className="text-danger">{errorMessage}</small>}
        </div>
        <div className="d-grid">
          <button type="submit" className="btn btn-primary">
            Sign Up
          </button>
        </div>
        <p className="forgot-password text-right">
          Already registered <a href="/login">Login</a>
        </p>
      </form>

      <Modals isOpen={isModalOpen} onClose={closeModal} message={modalMessage} />
    </div>
  );
}

export default Register;
